module.exports = __webpack_public_path__ + "img/software_rocket-matter.3bc3aa1d.jpg";